import throttle from 'lodash.throttle';
import './tabs.scss';

function fadeOut(el) {
    return new Promise((resolve, reject) => {
        el.style.opacity = 1;

        (function fade() {
            if ((el.style.opacity -= 0.1) < 0) {
                el.style.display = 'none';
                resolve('faded');
            } else {
                requestAnimationFrame(fade);
            }
        })();
    });
}

function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || 'block';

    (function fade() {
        let val = parseFloat(el.style.opacity);
        if (!((val += 0.1) > 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
}

const showError = tabsLength => {
    console.error(
        `We expect 2 matching HTML nodes, we have found: ${tabsLength}`
    );
    return false;
};

const changeTab = (contents, chosenChild) => {
    Promise.all([...contents.children].map(child => fadeOut(child))).then(
        () => {
            fadeIn(chosenChild);
        }
    );
};

const nTabs = selector => {
    const tabsElements = [
        ...document.querySelectorAll(`[data-tabs~="${selector}"]`),
    ];

    if (tabsElements.length !== 2) {
        return showError(tabsElements.length);
    }

    const [header, contents] = tabsElements;

    const toggleContent = (e, headerTarget) => {
        const tabIndex = [].indexOf.call(headerTarget.children, e.target);
        if (!e.target.classList.contains('active') && contents.children[tabIndex]) {
            [...headerTarget.children].map(child =>
                child.classList.remove('active')
            );
            e.target.classList.add('active');
            changeTab(contents, contents.children[tabIndex]);
        }
    };

    header.addEventListener(
        'click',
        throttle(e => toggleContent(e, header), 200)
    );
};

export default nTabs;
